import $ from 'jquery';

const languageItem = (language, lngTxt) => {
  return `<option value="${language}" data-lang="${language}">${lngTxt}</option>`;

};

const bagless_logo = `
  <div class='bagless_logo returnToWordpress'>
    <img src='/textures/bagless_logo.svg' id='bagless_logo' />
  </div>
`;

const versions = `
<div class="app-dropdown">
    <span id="room-version-dropdown-btn" class="material-icons clickable app-dropdown__button">history</span>
    <ul id="room-version-dropdown-menu" class="app-dropdown__menu">
        <li class="app-dropdown__item app-dropdown__item--template">
            <div>
                <div class="app-dropdown__item__name"></div>
                <div class="app-dropdown__item__time"></div>
            </div>
        </li>
  </ul>
</div>`
const preview = `<span id="preview_mode" class='changes_handler_btn' data-lang="preview-text">Preview</span>`;
const publish = `<div id="publish_changes" class='changes_handler_btn buttn secondary' data-lang="publish-text">Publish</div>`;
const view = `<div id='toggleModes' title='Switch to view mode' data-lang="view-mode-title"><span class="material-icons-outlined goToViewMode">visibility</span></div>`;
const lockEditor = `<div id="lockEditor-toggle" class="flex-inline-center"><span class="lockEditor-label">Lock</span><div class='toggleSwitch'><input type='checkbox' id='lockEditor'/><label for='lockEditor'><div class="switch"></div></label></div></div>`;
const exitApp = `<span class='material-icons clickable' id='exit_app'>exit_to_app</span>`;
const help = `<span class='material-icons clickable usetiful_help tobehide' id='usetiful_help'>help_outline</span>`;

const topnav_more = `<span class="material-icons-outlined topnav_more clickable">more_horiz</span>`;

const viewMobile = `<span id='toggleModes' title='Switch to view mode' data-lang="nav-view-mode">Go to view mode</span>`;
const exitAppMobile = `<span id='exit_app'exit-text data-lang="exit-text">Exit</span>`;
const helpMobile = `<span class='clickable usetiful_help' data-lang="help-text">Help</span>`;

const topnav_dropdown = `<ul class="topnav_more_dopdown"></ul>`;
const topnav_dropdown_items = `
<li>${preview}</li>
<li>${viewMobile}</li>
<li>${helpMobile}</li>
<li>${exitAppMobile}</li>
`;



const template = `
<div class="navbar-holder">
<div id="navbar-holder">
<section class='left-nav-side'>
  ${exitApp}
  <h2 data-lang="user-profile-edit-room">Edit room</h2>
</section>
<section class='middle-nav'>
${bagless_logo}
</section>
<section class='right-nav-side'>
  ${lockEditor}
  ${preview}
  ${publish}
  ${view}
  ${versions}

  ${topnav_more}
  ${topnav_dropdown}
</section>
</div>
</div>
`;

/**
 * Navbar for edit mode
 * @class DefaultNavbar
 */

class DefaultNavbar {

  constructor() {
    this.init();
  };

  init() {
    this.wrapper = $(template);
    this.topDropWrapper = $(topnav_dropdown);
    this.mobileDropdownitems = $(topnav_dropdown_items);
    $(document.body).append(this.wrapper);
    $('.topnav_more_dopdown').append(this.mobileDropdownitems);
  }
}

export { DefaultNavbar }
